var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),(_vm.graphdata)?_c('v-card-text',[_c('dist-chart',{staticClass:"dist-chart",attrs:{"chartdata":_vm.graphdata,"color":_vm.color}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }